var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWifiShowApnHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_wifi_showAPN_hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_wifi_showAPN_hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,6.5 C11,5.675 11.675,5 12.5,5 C13.325,5 14,5.675 14,6.5 C14,7.325 13.325,8 12.5,8 C11.675,8 11,7.325 11,6.5 Z",
    id: "Path-Copy-2",
    fill: "#69B4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,11.5 C11,10.675 11.675,10 12.5,10 C13.325,10 14,10.675 14,11.5 C14,12.325 13.325,13 12.5,13 C11.675,13 11,12.325 11,11.5 Z",
    id: "Path-Copy-3",
    fill: "#69B4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,16.5 C11,15.675 11.675,15 12.5,15 C13.325,15 14,15.675 14,16.5 C14,17.325 13.325,18 12.5,18 C11.675,18 11,17.325 11,16.5 Z",
    id: "Path-Copy-4",
    fill: "#69B4D9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWifiShowApnHover);
export default __webpack_public_path__ + "static/media/icon_wifi_showAPN_hover.5d27da169af3e8ca887ec8902d08e885.svg";
export { ForwardRef as ReactComponent };